import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import Gauge from "../Components/Gauge";
import { getTds, getWaterTemperature } from "./helper/coreapicall";

// import GettingDataAlert from "../Components/GettingDataAlert";

const Home = () => {
  var [tds, setTds] = useState(0);
  var [waterTemperature, setWaterTemperature] = useState(0);

  // TDS states
  var [tdsSensorStatus, setTdsSensorStatus] = useState("Normal");
  var [tdsNeedlePosition, setTdsNeedlePosition] = useState(0.0);
  var [tdsWarningColor, setTdsSensorWarningColor] = useState("success");

  // Water Temperature States
  var [waterTemperatureSensorStatus, setWaterTemperatureSensorStatus] =
    useState("Normal");
  var [
    waterTemperatureSensorNeedlePosition,
    setWaterTemperatureSensorNeedlePosition,
  ] = useState(0.0);
  var [waterTemperatureWarningColor, setWaterTemperatureWarningColor] =
    useState("success");

  // const [retriveData, setRetriveData] = useState(true);

  const currentPositionOfTDSNeedle = (tds) => {
    console.log(tds, "At currentNeedlePosition");
    return setTdsNeedlePosition(() => 0.1 * (tds / 50));
  };

  const currentTDSSensorStatus = (tds) => {
    console.log(tds, "Updated TDS Value");
    if (tds < 170) {
      // Action Required (Yellow)
      setTdsSensorStatus((s) => "Attention Required!");
      setTdsSensorWarningColor((s) => "warning");
    } else if (tds >= 170 && tds < 200) {
      // Normal
      setTdsSensorStatus("Normal");
      setTdsSensorWarningColor("success");
    } else {
      // Cation (Red)
      setTdsSensorStatus("Caution");
      setTdsSensorWarningColor("danger");
    }
  };

  // For Temperature

  // Water Temperature Status
  const currentTempStatus = (waterTemperature) => {
    console.log(waterTemperature, "Updated Water Temperature");

    if (waterTemperature < 20) {
      setWaterTemperatureSensorStatus("Attention Required");
      setWaterTemperatureWarningColor("warning");
    } else if (waterTemperature >= 20 && waterTemperature <= 40) {
      // NORMAL
      setWaterTemperatureSensorStatus("Normal");
      setWaterTemperatureWarningColor("success");
    } else {
      // Cation (RED)
      setWaterTemperatureSensorStatus("Caution");
      setWaterTemperatureWarningColor("danger");
    }
  };

  useEffect(() => {
    const preloadTDS = () => {
      return getTds()
        .then((data) => {
          data.feeds[0].field1 != null
            ? setTds(data.feeds[0].field1)
            : setTds(0);
          console.log(tds, " => TDS value");
          // currentTDSSensorStatus();
          // currentPositionOfTDSNeedle();
        })
        .catch((err) => console.log(err));
    };
    const preloadWaterTemperature = () => {
      return getWaterTemperature()
        .then((data) => {
          data.feeds[0].field2 != null
            ? setWaterTemperature(data.feeds[0].field2)
            : setWaterTemperature(0);
          console.log(waterTemperature, "Water Temperature Value");
          // currentTempNeedlePosition();
          // currentTempStatus();
        })
        .catch((err) => console.log(err));
    };

    const currentTempNeedlePosition = (waterTemperature) => {
      setWaterTemperatureSensorNeedlePosition(0.1 * (waterTemperature / 5));
      console.log(waterTemperature, waterTemperatureSensorNeedlePosition);
    };

    const interval = setInterval(() => {
      console.log("Interval Triggered");
      preloadTDS(tds);
      preloadWaterTemperature(waterTemperature);
      currentPositionOfTDSNeedle(tds);
      currentTempNeedlePosition(waterTemperature);
      currentTDSSensorStatus(tds);
      currentTempStatus(waterTemperature);
    }, 7000);

    return () => clearInterval(interval);
  }, [tds, waterTemperature, waterTemperatureSensorNeedlePosition]);

  // For TDS sensor

  return (
    <div>
      <div className="text-center container-fluid py-3 jumbotron">
        <h1
          style={{
            textTransform: "uppercase",
            fontFamily: "'Alfa Slab One', 'cursive'",
          }}
          className="display-6"
        >
          Hydroponics Monitoring System
        </h1>
      </div>
      {/* <h3> TDS = {tds}</h3>
      <h3> Water Temperature = {waterTemperature}</h3> */}
      <div className="row text-center">
        <Card
          className="col-6"
          style={{ width: "18rem", alignItems: "center" }}
        >
          <Gauge
            title="TDS"
            description="Monitor TDS value"
            variant={tdsWarningColor}
            deviceStatus={tdsSensorStatus}
            positionOfNeedle={tdsNeedlePosition}
            noOfLevels={10}
            sensorText="TDS"
            sensorValue={tds}
            unit="ppm"
          />

          <iframe
            width="480"
            height="300"
            title="TDS"
            src="https://thingspeak.com/channels/1464712/charts/1?bgcolor=%23ffffff&color=%23d62020&dynamic=true&results=60&type=line&update=15"
          ></iframe>
        </Card>

        <Card
          className="col-6"
          style={{ width: "18rem", alignItems: "center" }}
        >
          <Gauge
            title="Water Temperature"
            description="Monitor Temperature Sensor"
            variant={waterTemperatureWarningColor}
            deviceStatus={waterTemperatureSensorStatus}
            positionOfNeedle={waterTemperatureSensorNeedlePosition}
            noOfLevels={10}
            sensorText="Water Temperature"
            sensorValue={waterTemperature}
            unit="°C"
          />
          <iframe
            width="480"
            height="300"
            title="Water Temperature"
            src="https://thingspeak.com/channels/1464712/charts/2?bgcolor=%23ffffff&color=%23d62020&dynamic=true&results=60&type=line&update=15"
          ></iframe>
        </Card>
      </div>

      <div>
        <Card className="text-center py-5">
          <Card.Footer className="text-muted">
            <p> Hydroponics version: 2.0 </p>
            <span
              style={{
                color: "#87A8A4",
              }}
            >
              {" "}
              Debajit, Mayur, Sushan, Darshana, Priyanka &copy; 2021
            </span>
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
};

export default Home;
